import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DomSanitizerModule } from '@epicuro-next/ataraxia/dom-sanitizer';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { TooltipDirective } from '@epicuro-next/ataraxia/tooltip';

import { AttributesPanelComponent } from './attributes-panel/attributes-panel.component';
import { IndicatorsPanelComponent } from './indicators-panel/indicators-panel.component';
import { NoDataPanelComponent } from './no-data-panel/no-data-panel.component';
import { WarningPanelComponent } from './warning-panel/warning-panel.component';

const PUBLIC_DECLARATIONS = [
  IndicatorsPanelComponent,
  AttributesPanelComponent,
  NoDataPanelComponent,
  WarningPanelComponent,
];

@NgModule({
  declarations: PUBLIC_DECLARATIONS,
  imports: [CommonModule, IconsModule, TooltipDirective, DomSanitizerModule],
  exports: PUBLIC_DECLARATIONS,
})
export class PanelsModule {}
